module.exports = __webpack_public_path__ + "img/IMG_1185X407-03.49f7abe5.jpg";